<template>
  <div>
    <p
    class="text-justify pb-3"
    >
      Ingresa con tus credenciales de Ciudadania Digital, para poder realizar tramites digitales, presiona en el boton.
    </p>
    <v-btn
      ref="botonCiudadaniaDigital"
      block
      large
      color="#90bc1d"
      outlined
      rounded
      @click="start_session_ciudadania()"
      :loading="loading_ciudadania"
    >
      <img src="@/assets/btn_ciudadania_digital_v2.png" width="120" />
    </v-btn>
    <p class="pt-5 mb-2">¿No tienes cuenta en ciudadania? <a href="https://www.gob.bo/ciudadania/registrate" target="_blank" style="text-decoration: none" class="blue--text">Registrate aquí</a></p>
    <p>¿Olvidaste tu contraseña? <a href="https://www.gob.bo/ciudadania/password" target="_blank" style="text-decoration: none" class="blue--text">Presiona aquí</a></p>
  </div>
</template>
<script>
import OpenID from "@/components/mixins/openid";
export default {
  data() {
    return {
      loading_ciudadania: false
    };
  },
  mounted() {
    this.tokenOpenID();
    this.$storage.set("tipo", 'ciudadania');
    this.$store.commit('setTipo','Ciudadania');
  },
  mixins: [OpenID],
  methods: {
    start_session_ciudadania() {
      this.$Progress.start();
      this.loginOpenID();
    }
  }
};
</script>